import { LocalizationProviderProps } from '@alice-financial/alice-sdk'
import { ExternalLink, Link, PII } from '@alice-financial/pretext-ui'
import * as React from 'react'
import { LoginLink } from '../app/auth/LoginLink'
import { ENGLISH_TRNS } from './messages/en-us'
import { SPANISH_TRNS } from './messages/es'

export const localizationProps: Omit<LocalizationProviderProps, 'children'> = {
  messageMap: {
    'en-us': ENGLISH_TRNS,
    es: SPANISH_TRNS,
  },
  defaultRichTextElements: {
    pii: (...chunks) => <PII>{chunks}</PII>,
    'link-login': (...chunks) => <LoginLink>{chunks}</LoginLink>,
    'link-pw-reset': (...chunks) => <Link to="/forgot-password">{chunks}</Link>,
    'email-admin-support': () => (
      <ExternalLink href="mailto:admin-support@thisisalice.com">admin-support@thisisalice.com</ExternalLink>
    ),
    'link-eligible-expenses': (...chunks) => (
      <ExternalLink href="https://help.thisisalice.com/article/52-what-expenses-are-commuter-eligible">
        {chunks}
      </ExternalLink>
    ),
  },
} as const
